<template>
  <QAvatar
    v-bind="$attrs"
    :color="color"
    :text-color="textColor"
    :icon="icon"
    :font-size="fontSize"
    :class="['sai-avatar', { bottom: bottom, 'overflow-hidden': bottom }]"
  />
</template>

<script>
import { QAvatar } from 'quasar';

export default {
  name: 'SAIAvatar',
  props: {
    bottom: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'grey-4'
    },
    textColor: {
      type: String,
      default: 'white'
    },
    icon: {
      type: String,
      default: 'eva-person'
    },
    fontSize: {
      type: String,
      default: '42px'
    }
  },
  components: {
    QAvatar
  }
};
</script>

<style lang="sass" scoped>
.sai-avatar.bottom::v-deep
  .q-avatar__content
    position: relative
    bottom: -8px
</style>
